import React, { useState } from "react";
import { PageHeader } from "components/ui";
import { Grid, Box } from "@mui/material";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import {
  getAnnexure9,
  FEDRAL_LAW_REGULATION_SINGAPORE,
  PROVISIONAL_TERRITORY_SINGAPORE,
  FEDRAL_PROVINCIAL_REQ_SINGAPORE,
} from "data/standards/griStandards";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import { COUNTRIES_COMPLIANCE_FORM } from "data/forms/griFormSchema";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";

const Singapore = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const [showReviewPopup, setShowReviewPopup] = useState(false);

  const steps = [
    "Select Singapore Laws / Acts",
    "Select Singapore Regulations / Subsidiary Legislation",
    "Select Singapore ESHS Standards & Guidelines",
    "Singapore ESG Compliance Data Collection Form",
    "Singapore Reports / Assessments / Analysis",
    "Download Gap Form",
    "Upload Gap Form",
    "Download Review Reports",
  ];

  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(5);
    setShowReviewPopup(false);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <StandardsSelector
            standards={FEDRAL_LAW_REGULATION_SINGAPORE}
            onNext={handleNext}
            onSave={handleSaveStandards}
            title="Select Singapore National Law/Regulation from the options below"
            nextButtonText="Next"
            initialSelectedStandards={reportData.selectedStandards.map(
              (s) => s.id
            )}
          />
        );

      case 1:
        return (
          <StandardsSelector
            standards={PROVISIONAL_TERRITORY_SINGAPORE}
            onNext={handleNext}
            onSave={handleSaveStandards}
            title="Select Agency / Statutory Board Guidelines from the options below"
            nextButtonText="Next"
            initialSelectedStandards={reportData.selectedStandards.map(
              (s) => s.id
            )}
          />
        );
      case 2:
        return (
          <StandardsSelector
            standards={FEDRAL_PROVINCIAL_REQ_SINGAPORE}
            onNext={handleNext}
            onSave={handleSaveStandards}
            title="Select Compliance & ESG Requirements from the options below"
            nextButtonText="Next"
            initialSelectedStandards={reportData.selectedStandards.map(
              (s) => s.id
            )}
          />
        );
      case 3:
        return (
          <ReusableFormComponent
            key="form-step-singapore"
            {...COUNTRIES_COMPLIANCE_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 4:
        return (
          <StandardsSelector
            standards={getAnnexure9("Singapore")}
            onNext={handleNext}
            onSave={handleSaveStandards}
            title=""
            showReportCountdownButton={true}
            nextButtonText="Next"
            initialSelectedStandards={reportData.selectedStandards.map(
              (s) => s.id
            )}
          />
        );
      case 5:
        return (
          <DownloadPostReviewGapForm
            key="gap-download-step-singapore"
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );

      case 6:
        return (
          <UploadPostReviewGapForm
            key="gap-upload-step-singapore"
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );

      case 7:
        return (
          <DownloadPostReviewReports
            key="post-review-download-step-singapore"
            onPrevious={handleBack}
            showReportCountdownButton={true}
            standardName="Singapore ESG Compliance"
          />
        );

      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NavigationButtons
                imageKey="dashboardImg4_2"
                title={"Singapore ESG Compliance"}
                activeStep={activeStep}
                onBack={handleBack}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: -1,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToStep5}
      />
    </>
  );
};

export default Singapore;
